import api from './AxiosInstance';

export class ReglementsService {

    /* api/Encaiss/PreviewCompta */
                        /* api/Encaiss/ValidPreviewCompta */
  annulerApayerReglementFact= async (payload) => {
    try {
      const response = await api.put(`Facture/updateEtapeFacture/NP`, payload, {
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
 apayerReglementFact= async (payload) => {
  try {
    const response = await api.put(`/Facture/updateEtapeFacture/AP`, payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};
addValidComptaReg = async (payload) => {
  try {
    const response = await api.post(`/Compta/ValidPreviewCompta/10`,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
}; 
addValidComptaEncaiss = async (payload) => {
  try {
    const response = await api.post(`Encaiss/ValidPreviewCompta`,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
}; 

previewAnnulationComptaReg = async (payload) => {
  try {
    const response = await api.post(`/Facture/PreviewCanceledFacture`, payload,{
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};
addPreviewAnnulationComptaReg = async (payload) => {
  try {
    const response = await api.post(`/Compta/ValidPreviewComptaFactureAnnuler/Reg`, payload,{
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};

updateAnnulationCompta = async (payload) => {
  try {
    const response = await api.put(`/Facture/updateEtapeFacture/NN`,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
};

 


  getReglementations = async (selectedYear, selectedOption) => {
    try {
      const response = await api.get(`/Facture/Reglement/list/${selectedOption}?exercice=${selectedYear}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  getReglementationDivers = async (selectedYear, selectedOption) => {
    try {
      const response = await api.get(`/Facture/Divers/Reglement/list/${selectedOption}?exercice=${selectedYear}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  
  getReg = async () => {
    try {
      const response = await api.get(`/Facture/Exercices/Reg`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

getSoldeReg = async (compte_rattache) => {
  try {
    const response = await api.get(`Facture/Reg/Solde/${compte_rattache}`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
  
  }
};

  getSaisieReg = async () => {
    try {
      const response = await api.get(`SaisieJournal/list/Reg`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };

  getParamReg = async () => {
    try {
      const response = await api.get(`/InfosGen/DateCompta/param3`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  }; 
 

 updateSaisieReg = async (payload) => {
  try {
    const response = await api.put(`Facture/updateSaisieRegFacture`, payload,{

    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
  
  }
};

updateSaisieEncaisse = async (payload) => {
  try {
    const response = await api.put(`/Facture/updateSaisieEncaissement`, payload,{

    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
  
  }
};

cancelSaisieReg = async (payload) => {
  try {
    const response = await api.put(`Facture/Reglement/Cancel`, payload,{

    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
  
  }
};
ComptaRegPreviewCompta = async (payload) => {
  try {
    const response = await api.post(`/Compta/PreviewCompta/10`,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
}; 
ComptaEncaissPreviewCompta = async (payload) => {
  try {
    const response = await api.post(`/Encaiss/PreviewCompta `,payload, {
   
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des données :', error);
    // Gérer l'erreur ici si nécessaire
    throw error; 
  }
}; 
//api/Encaiss/PreviewCompta 

}


